export default __webpack_public_path__ + "static/media/multi-cloud-line-art.e7d96494.svg";